import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  const stats = [{
    value: '51',
    label: 'Bytových jednotek'
  }, {
    value: '2',
    label: 'Podzemní patra garáží'
  }, {
    value: '3',
    label: 'Nadzemní podlaží'
  }, {
    value: '∞',
    label: 'Výhledy do přírody'
  }];
  return <section id="o-projektu" className="py-24 bg-base-cream" data-id="element-13">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-15">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-16">
            <h2 className="font-heading text-4xl md:text-5xl text-primary mb-6" data-id="element-17">
              O projektu
            </h2>
            <div className="space-y-6 text-base-gray text-lg leading-relaxed" data-id="element-18">
              <p data-id="element-19">
                Rezidenční projekt <strong data-id="element-20">Svatý Václav</strong> představuje
                unikátní spojení moderní architektury a klidného příměstského
                života. Nachází se v malebné obci Dolní Jirčany, na dosah
                hlavního města Prahy, a přesto v těsném kontaktu s přírodou.
              </p>
              <p data-id="element-21">
                Za projektem stojí developerská společnost{' '}
                <strong data-id="element-22">Bramal, s.r.o.</strong>, která klade důraz na
                ekologickou udržitelnost, prémiové materiály a promyšlené
                dispoziční řešení. Komplex nabízí 50 bytových jednotek
                doplněných o komerční prostory pro maximální komfort obyvatel.
              </p>
              <p data-id="element-23">
                Součástí projektu jsou dvě patra podzemních garáží zajišťující
                dostatek parkovacích míst a prostorné sklepní kóje pro každou
                jednotku.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-24">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl" data-id="element-25">
              <img src="https://cdn.magicpatterns.com/uploads/39KQJnk7h7vyeYhmKC3uMY/1.png" alt="Pohled na projekt Svatý Václav" className="w-full h-full object-cover" data-id="element-26" />
            </div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-primary/10 rounded-full -z-10 blur-2xl" data-id="element-27"></div>
            <div className="absolute -top-6 -right-6 w-40 h-40 bg-accent/10 rounded-full -z-10 blur-2xl" data-id="element-28"></div>
          </motion.div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-primary/10 pt-16" data-id="element-29">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="text-center" data-id="element-30">
              <div className="font-heading text-5xl md:text-6xl text-accent mb-3" data-id="element-31">
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-base-dark font-medium uppercase tracking-wider" data-id="element-32">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}